import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import useAuthenticatedData from '../hooks/useAuthenticatedData';
import { type } from '@testing-library/user-event/dist/type';

// Register the necessary Chart.js pieces
ChartJS.register(ArcElement, Tooltip, Legend);

const PurchasingSpendGoal = () => {
  
  const formatFigure = (figure) => {
    /* if (figure >= 1_000_000) {
      return (figure / 1_000_000).toFixed(2) + 'M';
    }
    return Math.round(figure).toLocaleString();  */
    return Math.floor(figure).toLocaleString();
  };



  const options = {
    type: 'doughnut',
    rotation: 270,
    responsive: true,
    circumference: 180,
    maintainAspectRatio: true,
    responsive: true,
    animation: {
      duration: 0
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          color: 'white',
          font: {
            size: window.innerHeight * 0.015
          }
        },
      }
    }

  };

  // get the current month as MMM
  const monthNow = new Date().toLocaleString('default', { month: 'short' });

  const apiUrl = process.env.REACT_APP_CONTROL_API_URL;
  var url = apiUrl + 'monitor/purchasing-spend-goal';
  const { data, isLoading, error } = useAuthenticatedData(url);

  //const { data, isLoading, error } = useAuthenticatedData('https://localhost:5001/monitor/purchasing-spend-goal');

  if ((data != null) && (data.chartData != null)) {

    return (
      <div style={{ textAlign: 'center', backgroundColor: 'black' }}>
        <div className='col-sm-12 '>
          <p style={{ fontSize: '2.5vh', color: '#ffd240', margin: '0', fontWeight: 'bold' }}>PURCHASING VALUE GOAL</p>
        </div>
        <div className='row'>
          <div className='col-sm-6 '>
            <p style={{ fontSize: '2vh', color: 'white', margin: '0', fontWeight: 'bold' }}>{monthNow.toUpperCase()} VALUE GOAL</p>
            <p style={{ fontSize: '1vh', color: '#bab8b8', margin: '0', fontWeight: 'bold' }}>(Purchasing value goal for current month)</p>
            <p style={{ fontSize: '2vh', color: 'white', margin: '0', fontWeight: 'bold' }}>${formatFigure(data.monthSpendGoal)}</p>
          </div>
          <div className='col-sm-6 '>
            <p style={{ fontSize: '2vh', color: 'white', margin: '0', fontWeight: 'bold' }}>SCHEDULED VALUE</p>
            <p style={{ fontSize: '1vh', color: '#bab8b8', margin: '0', fontWeight: 'bold' }}>(All PO's with a ship date of this month)</p>
            <p style={{ fontSize: '2vh', color: 'white', margin: '0', fontWeight: 'bold' }}>${formatFigure(data.scheduledSpend)}</p>
          </div>
        </div>
        
        <div className='row sc-doughnut-chart-padding '>
          <div className='col-sm-12 '>
            <Doughnut data={data.chartData} options={options} style={{ maxWidth: '100%', maxHeight: '20vh' }} />
          </div>
        </div>
        
        <div className='row'>
          <div className='col-sm-6 '>
            <p style={{ fontSize: '2vh', color: 'white', margin: '0', fontWeight: 'bold' }}>RECEIVED VALUE</p>
            <p style={{ fontSize: '1vh', color: '#bab8b8', margin: '0', fontWeight: 'bold' }}>(All value received this month)</p>
            <p style={{ fontSize: '2vh', color: 'white', margin: '0', fontWeight: 'bold' }}>${formatFigure(data.receivedSpend)}</p>
          </div>
          <div className='col-sm-6 '>
            <p style={{ fontSize: '2vh', color: 'white', margin: '0', fontWeight: 'bold' }}>GAP</p>
            <p style={{ fontSize: '1vh', color: '#bab8b8', margin: '0', fontWeight: 'bold' }}>(Goal minus scheduled & received value)</p>
            <p style={{ fontSize: '2vh', color: 'white', margin: '0', fontWeight: 'bold' }}>${formatFigure(data.gap)}</p>
          </div>
        </div>
      </div>
    );
  }


}

export default PurchasingSpendGoal;
